import { render, staticRenderFns } from "./examinationVisualAcuity.vue?vue&type=template&id=8418007c&scoped=true&"
import script from "./examinationVisualAcuity.vue?vue&type=script&lang=js&"
export * from "./examinationVisualAcuity.vue?vue&type=script&lang=js&"
import style0 from "./examinationVisualAcuity.vue?vue&type=style&index=0&id=8418007c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8418007c",
  null
  
)

export default component.exports